module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Demi.de28f71e.otf";